import { render } from "./PrizesDialog.vue?vue&type=template&id=470c8af2&scoped=true"
import script from "./PrizesDialog.vue?vue&type=script&lang=js"
export * from "./PrizesDialog.vue?vue&type=script&lang=js"

import "./PrizesDialog.vue?vue&type=style&index=0&id=470c8af2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470c8af2"]])

export default __exports__